module.exports = {
    dateSorters : ['Today', 'This Week', 'This Month', 'This Year', 'Last Month', 'Last Year'],
    columnsBy   : [
        { text: "Total", value: "1"},
        { text: "Month", value: "12" },
        { text: "Quarter", value: "4" },
        { text: "Semi-Annual", value: "2" },
    ],
};